import { Observable } from 'rxjs';
import { ReminderAnalyticsQuery, ReminderSnapshotResponse, ReminderDistributionResponse, ReminderTrendsResponse } from './reminder-analytics.model';

export abstract class ReminderAnalyticsService {
    abstract getSnapshot(query: ReminderAnalyticsQuery): Observable<ReminderSnapshotResponse>;
    abstract getDistribution(query: ReminderAnalyticsQuery): Observable<ReminderDistributionResponse>;
    abstract getTrends(query: ReminderAnalyticsQuery): Observable<ReminderTrendsResponse>;
}
